import { contatoData } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer className="bg-footer-dark py-14 md:py-16">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
          {/* Branding */}
          <div className="text-center sm:text-left">
            <p className="font-display text-white/90 text-base md:text-lg font-light tracking-wide">
              Stephanie Zarowny Arquitetura e Interiores
            </p>
            <p className="font-body text-white/40 text-xs font-light mt-3">
              Curitiba, Brasil.
            </p>
          </div>

          {/* Social icons */}
          <div className="flex items-center gap-4">
            <a
              href="https://wa.me/5541996214861"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
              className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 text-white hover:bg-[#25D366] hover:text-white transition-colors duration-300"
            >
              <i className="ri-whatsapp-line text-lg" />
            </a>
            <a
              href="https://www.instagram.com/arq.stephaniezarowny/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 text-white hover:bg-[#E4405F] hover:text-white transition-colors duration-300"
            >
              <i className="ri-instagram-line text-lg" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}